import React, { useCallback, useEffect, useRef } from "react";

type Props = {
  PagingUpdate: () => void;
};

function Infinite({ PagingUpdate }: Props) {
  const dom = useRef<HTMLDivElement | null>(null);
  const handleScroll = useCallback(
    ([entry]: IntersectionObserverEntry[]) => {
      if (entry.isIntersecting) {
        PagingUpdate();
      }
    },
    [PagingUpdate]
  );

  useEffect(() => {
    const el = dom.current;
    if (!el) return;
    const observer = new IntersectionObserver(handleScroll, {
      root: null,
      rootMargin: "0px 0px 400px 0px",
      threshold: 0,
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [handleScroll]);

  return (
    <div
      ref={dom}
      aria-hidden
      style={{ minHeight: 1, width: "100%", gridColumn: "1 / -1" }}
    />
  );
}

export default Infinite;
